import React from 'react';
const BG_URL = 'https://cdn.magicpatterns.com/uploads/jiEwbNvMzMQ7hraX7mj8EN/Chimbuk-Hills.jpg_1.png';
const GOV_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/dU3qapA9H2XyT3LbpNWDjq/Government_Seal_of_Bangladesh.svg_1.png';
interface KioskScreenProps {
  children: React.ReactNode;
  showFooter?: boolean;
  /** When true, render the full gov header (used on Home). When false, render a slim brand strip. */
  fullHeader?: boolean;
}
export function KioskScreen({
  children,
  showFooter = true,
  fullHeader = false
}: KioskScreenProps) {
  return <div className="relative h-screen w-full overflow-hidden" data-id="element-34">
      {/* Background image (reduced opacity) */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url('${BG_URL}')`,
      opacity: 0.55
    }} data-id="element-35" />
      {/* Soft overlay for legibility */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/40 to-emerald-900/30" data-id="element-36" />

      {/* Content */}
      <div className="relative z-10 flex flex-col h-full" data-id="element-37">
        {/* Top Government Header */}
        <header className="bg-white/90 backdrop-blur-md border-b border-emerald-700/15 shadow-sm shrink-0" data-id="element-38">
          <div className="max-w-7xl mx-auto px-6 py-3 flex items-center gap-4" data-id="element-39">
            <img src={GOV_LOGO_URL} alt="Government Seal of Bangladesh" className="w-12 h-12 md:w-14 md:h-14 object-contain shrink-0" data-id="element-40" />
            <div className="leading-tight" data-id="element-41">
              <p className="text-base md:text-lg font-bold text-slate-900" data-id="element-42">
                গণপ্রজাতন্ত্রী বাংলাদেশ সরকার
              </p>
              <p className="text-sm md:text-base text-emerald-800 font-medium" data-id="element-43">
                জেলা প্রশাসন, বান্দরবন পার্বত্য জেলা
              </p>
            </div>
            {!fullHeader && <div className="ml-auto hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-50 border border-emerald-200" data-id="element-44">
                <span className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-45" />
                <span className="text-xs font-semibold text-emerald-700" data-id="element-46">
                  চিম্বুক পাহাড় টিকিটিং সিস্টেম
                </span>
              </div>}
          </div>
        </header>

        {/* Main content area */}
        <div className="flex-1 min-h-0 flex flex-col" data-id="element-47">{children}</div>

        {/* Footer */}
        {showFooter && <footer className="shrink-0 px-6 pb-3 pt-2" data-id="element-48">
            <div className="max-w-6xl mx-auto flex items-center justify-center" data-id="element-49">
              <div className="px-4 py-1.5 rounded-full bg-white/80 backdrop-blur-md border border-emerald-700/10 shadow-sm" data-id="element-50">
                <p className="text-sm font-medium text-slate-700" data-id="element-51">
                  সহায়তার জন্য কাউন্টারে যোগাযোগ করুন
                </p>
              </div>
            </div>
          </footer>}
      </div>
    </div>;
}